import { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useIndustryFilters from "~/hooks/useIndustryFilters";
import { AdvancedSearchContext } from "~/providers/AdvancedSearchProvider";
import AdvancedSearchFilterBar from "~/features/AdvancedSearch/AdvancedSearchFilterBar";
import ItemList2 from "../ListLayout/ItemList2";
import FilterToggle from "../ListToggle/FilterToggle";
import { FilterOption } from "~/types/filters.types";

const Industries = () => {
    const { t } = useTranslation();
    const { industries, search, setSearch, isLoading } = useIndustryFilters();

    const { industryFilters, setIndustryFilters, setTriggerSearch } =
        useContext(AdvancedSearchContext);

    // Temp list for changes before update event
    const [tempList, setTempList] = useState<FilterOption[]>(industryFilters);
    const enableUpdate =
        tempList.length !== industryFilters.length ||
        !industryFilters.every(f => tempList.find(tf => tf.id === f.id));

    const handleUpdate = () => {
        // Update context data when update button is clicked
        if (tempList.length > 0) {
            setIndustryFilters(tempList);
        } else {
            setIndustryFilters([]);
        }

        setTriggerSearch(true);
    };

    const resetItems = () => {
        setSearch("");
        // setTempList(industryFilters);
    };

    useEffect(() => {
        if (industryFilters.length !== tempList.length) setTempList(industryFilters);
    }, [industryFilters]);

    return (
        <FilterToggle label={t("industry")} count={tempList.length} panelWidth={"w-[104px]"}>
            {({ open }) => (
                <>
                    <AdvancedSearchFilterBar
                        placeholder={`${t("searchCategory2", { category: t("industry").toLowerCase() })}`}
                        search={search}
                        setSearch={setSearch}
                        bgColor="bg-stone-lighter"
                    />
                    <ItemList2
                        label={t("industries")}
                        items={industries}
                        listItems={tempList}
                        setListItems={setTempList}
                        reset={!open}
                        resetFn={resetItems}
                        enableUpdate={enableUpdate}
                        updateFn={handleUpdate}
                        enableSelectAll={false}
                        enableReset={true}
                        groupSelected={true}
                        autoUpdate={true}
                        isLoading={isLoading}
                    />
                </>
            )}
        </FilterToggle>
    );
};

export default Industries;
